import { render, staticRenderFns } from "./registration-page.vue?vue&type=template&id=6b057822&scoped=true&"
import script from "./registration-page.vue?vue&type=script&lang=js&"
export * from "./registration-page.vue?vue&type=script&lang=js&"
import style0 from "./registration-page.vue?vue&type=style&index=0&id=6b057822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b057822",
  null
  
)

export default component.exports